import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'zepbazaar_business_location_id';

@Injectable({ providedIn: 'root' })
export class BusinessLocationContextService {
  readonly selectedLocationId = signal<string | null>(this.read());

  select(locationId: string | null): void {
    const value = locationId?.trim() || null;
    this.selectedLocationId.set(value);
    if (typeof sessionStorage === 'undefined') return;
    if (value) sessionStorage.setItem(STORAGE_KEY, value);
    else sessionStorage.removeItem(STORAGE_KEY);
  }

  clear(): void {
    this.select(null);
  }

  private read(): string | null {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem(STORAGE_KEY);
  }
}
